import {
  Cars64,
  Tractors64,
  Livestock64,
  FarmMachinery64,
  BeddingFeed64,
  FarmersMarket64,
  FarmersNoticeboard64,
  FarmingServices64,
  FarmSheds64,
  FarmTools64,
  FeedingEquipment64,
  FencingEquipment64,
  Fertilisers64,
  OtherFarming64,
  PlantMachinery64,
  Poultry64,
  VintageMachinery64,
  Farming64,
  TractorsFromDealerships64,
} from '../../../components/Toolkit/Base64/Sections';
export interface Map {
  [name: string]: JSX.Element;
}

const FarmingIcons: Map = {
  cars: <Cars64 alt="" />,
  tractors: <Tractors64 alt="" />,
  tractorsfromdealerships: <TractorsFromDealerships64 alt="" />,
  livestock: <Livestock64 alt="" />,
  machinery: <FarmMachinery64 alt="" />,
  plantmachinery: <PlantMachinery64 alt="" />,
  farmproduce: <BeddingFeed64 alt="" />,
  farmersmarket: <FarmersMarket64 alt="" />,
  farmersnoticeboard: <FarmersNoticeboard64 alt="" />,
  farmservices: <FarmingServices64 alt="" />,
  farmsheds: <FarmSheds64 alt="" />,
  farmtools: <FarmTools64 alt="" />,
  feedingequipment: <FeedingEquipment64 alt="" />,
  fencingequipment: <FencingEquipment64 alt="" />,
  fertilisers: <Fertilisers64 alt="" />,
  otherfarming: <OtherFarming64 alt="" />,
  poultry: <Poultry64 alt="" />,
  vintagemachinery: <VintageMachinery64 alt="" />,
  farming: <Farming64 alt="" />,
};

export default FarmingIcons;
